import { useState } from "react";
import { Flex, Tooltip, Typography } from "antd";

import { LinkButton, TrashCanButton } from "ui";
import { formatFileInfo, getFileIcon, getFileNameWithoutExtension } from "utils";
import { ReactComponent as DownloadIcon } from "images/downloadIcon.svg";

import styles from "./editableFile.module.css";
import fileInputStyles from "../../Inputs/FileInput/fileInput.module.css";
import { DocDto } from "interfaces";

interface IProps {
  file: Partial<Omit<DocDto, "url" | "docName">> & Pick<DocDto, "url" | "docName">;
  removeFileHandler?: () => Promise<void>;
  showRemoveIcon?: boolean;
  tooltip?: string;
  removeTooltip?: string;
  showTooltip?: boolean;
}

export const EditableFile = ({
  file,
  removeFileHandler,
  showRemoveIcon = false,
  tooltip,
  removeTooltip,
  showTooltip = true,
}: IProps) => {
  const [loading, setLoading] = useState(false);
  const removeFile = async () => {
    if (!removeFileHandler) return;
    setLoading(true);

    await removeFileHandler().finally(() => setLoading(false));
  };

  const nameWithoutExtension = getFileNameWithoutExtension(tooltip ?? "");
  return (
    <Flex justify="space-between" gap="small" className={`full-width ${fileInputStyles.uploadedFileWrapper}`}>
      <Tooltip title={tooltip}>
        <Flex align="center" gap="small">
          <div className="square bg-basic-200 icon-3xl">{getFileIcon(file?.docName)}</div>
          <Flex vertical>
            <Typography.Text>{file?.docName}</Typography.Text>
            <Typography.Text className="text-hint">
              {file.uploadedAt &&
                file.fileSize &&
                formatFileInfo({ fileSize: file.fileSize, uploadedAt: new Date(file.uploadedAt) })}
            </Typography.Text>
          </Flex>
        </Flex>
      </Tooltip>
      <Flex gap="small">
        <LinkButton href={file?.url} download={file?.docName} disabled={loading}>
          <Tooltip title={showTooltip ? `Скачать документ ${nameWithoutExtension}` : undefined}>
            <DownloadIcon className={`${styles.actionIcon} cursor-pointer`} />
          </Tooltip>
        </LinkButton>
        {showRemoveIcon && (
          <Tooltip title={showTooltip ? (removeTooltip ?? `Удалить документ ${nameWithoutExtension}`) : undefined}>
            <TrashCanButton onRemove={removeFile} />
          </Tooltip>
        )}
      </Flex>
    </Flex>
  );
};
